import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import contactImg from '../assests/img/contact-img.svg';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
 

  const [result, setResult] = React.useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "a055217a-947d-47f1-a7fa-cf4f816cf82e");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
 
    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }}
    catch(error){
      console.error("Error submitting form", error);
    setResult("There was an error submitting the form. Please try again.");
    }
  };
  

  return (
    <section className='contact' id='connect'>
     <Container>
        <Row className='align-items-center'>
            <Col size={12} md={6}> 
            <TrackVisibility>
            {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
              
            </Col>
            <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
            <h2>Get in Touch</h2>
            <form onSubmit={handleSubmit} method="POST">
            <input type="hidden" name="access_key" value="a055217a-947d-47f1-a7fa-cf4f816cf82e"/>
                <Row>
                    <Col size={12} sm={6} className='px-1'>
                      <input type='text' name='first_name' placeholder='First Name' required />
                    </Col>
                    <Col size={12} sm={6} className='px-1'>
                    <input type='text' name='last_name' placeholder='Last Name' required/>
                    </Col>
                    <Col size={12} sm={6} className='px-1'>
                    <input type='email' placeholder='Email Address'name='email' required/>
                    </Col>
                    <Col size={12} sm={6} className='px-1'>
                    <input type='tel' placeholder='Phone No' name='number' required/>
                    </Col>
                    <Col size={12} className='px-1'>
                    <textarea rows="6" placeholder='Message' name='message' required></textarea>
                    <button type='submit'><span>Send</span></button>
                    </Col>
                    
                </Row>
            </form>
          <div className='container px-1 my-3 '>
            <span>{result}</span>
          </div>
            </div>}
            </TrackVisibility>
            </Col>
        </Row>
     </Container>
    </section>
  )
}
